import React, { useState, useEffect } from "react";
import CommonPopup from "Components/common/CommonPopup";
import makeApi, { URLS } from "Utils/apiURL";
import SpinnerLoader from "Components/common/SpinnerLoader";

const PaperPlaneIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 1.33334L7.33337 8.66668M14.6667 1.33334L10 14.6667L7.33337 8.66668M14.6667 1.33334L1.33337 6.00001L7.33337 8.66668"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UpRightArrow = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 9.5L9.5 2.5M9.5 2.5H4.5M9.5 2.5V7.5"
      stroke="#3953FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UsageAuditSkeleton = () => (
  <div className="usageAuditSkeleton">
    {[1, 2].map((section) => (
      <div key={section} className="auditSection">
        <div className="sectionHeader">
          <div className="statusDot linear-background"></div>
          <div className="sectionTitle skeleton linear-background" style={{ width: "120px", height: "16px", borderRadius: "4px" }}></div>
        </div>
        <div className="sequenceList" style={{ paddingLeft: "22px" }}>
          {[1, 2, 3].map((row) => (
            <div key={row} className="sequenceRow skeleton" style={{ marginBottom: "8px" }}>
              <div className="linear-background" style={{ width: "200px", height: "14px", borderRadius: "4px" }}></div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

const UsageAuditModal = ({ inboxId, email, onClose }) => {
  const [auditData, setAuditData] = useState(null);

  useEffect(() => {
    const fetchAudit = async () => {
      try {
        const response = await makeApi({
          url: URLS.getUsageAudit.replace("<<inboxId>>", inboxId),
          method: "GET"
        });
        if (response?.data) {
          setAuditData(response.data);
        }
      } catch (error) {
        console.error("Error fetching usage audit:", error);
      }
    };
    fetchAudit();
  }, [inboxId]);

  const renderSequenceList = (sequences, title, dotColor) => {
    // Only render if we have data or if it's explicitly empty after fetching
    if (!auditData) return null;

    const isEmpty = !sequences || sequences.length === 0;

    return (
      <div className="auditSection">
        <div className="sectionHeader">
          <span className="statusDot" style={{ backgroundColor: dotColor }}></span>
          <span className="sectionTitle">{title}</span>
        </div>
        <div className="sequenceList">
          {isEmpty ? (
            <div className="emptySectionMessage">No {title}</div>
          ) : (
            sequences.map(seq => (
              <div
                key={seq.sequenceId}
                className="sequenceRow"
                onClick={() => window.open(`/sequences/all/${seq.sequenceId}`, "_blank")}
              >
                <div className="seqInfo">
                  <PaperPlaneIcon className="seqIcon" />
                  <span className="seqName">{seq.name} <UpRightArrow /></span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  const CustomHeader = () => (
    <div className="usageAuditCustomHeader">
      <div className="headerTopRow">
        <h4 className="headerTitle">
          Usage Audit: <span className="emailLink">{email || auditData?.email || "..."}</span>
        </h4>
        <i className="material-icons closeIcon" onClick={onClose}>close</i>
      </div>
      <div className="headerSubTitle">
        This inbox is currently active in {auditData?.totalActiveCount || 0} {auditData?.totalActiveCount === 1 ? "sequence" : "sequences"}
      </div>
    </div>
  );

  if (!auditData) {
    return (
      <CommonPopup
        className="usageAuditModal"
        hasHeaderChildren={true}
        HeaderChildren={CustomHeader}
        closeIconCbk={onClose}
      >
        <div className="usageAuditBody">
          <div className="auditContent">
            <UsageAuditSkeleton />
          </div>
          <div className="auditFooter">
            <button className="okayBtn" onClick={onClose}>Okay</button>
          </div>
        </div>
      </CommonPopup>
    );
  }

  return (
    <CommonPopup
      className="usageAuditModal"
      hasHeaderChildren={true}
      HeaderChildren={CustomHeader}
      closeIconCbk={onClose}
    >
      <div className="usageAuditBody">
        <div className="auditContent">
          {renderSequenceList(auditData?.activeSequences, "Active Sequences", "#00D274")}
          {renderSequenceList(auditData?.inactiveSequences, "Connected But Inactive Sequences", "#AFAFAF")}
        </div>
        <div className="auditFooter">
          <button className="okayBtn" onClick={onClose}>Okay</button>
        </div>
      </div>
    </CommonPopup>
  );
};

export default UsageAuditModal;
